<template>
  <div class="index container">
    <transition name="fade">
      <router-view @showParent="showParent"> </router-view>
    </transition>

    <div v-if="showParentPage">
      <v-breadcrumbs>
        <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
          >Home</v-breadcrumbs-item
        >
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item
          :exact="true"
          :to="{ name: 'cardPaymentConfig', params: {} }"
          active
        >
          Card Payment Config
        </v-breadcrumbs-item>
      </v-breadcrumbs>

      <div class="d-flex flex-column flex-lg-row">
        <v-text-field
          dense
          v-model="searchTerms"
          @keyup.enter="search"
          @click:clear="clearSearch"
          @click:append="search"
          placeholder="Press enter to begin search"
          append-icon="mdi-magnify"
          outlined
          clearable
          label="Search"
        />
        <v-btn
          class="ml-0 ml-lg-4 mb-2 mb-lg-0 align-self-end align-self-lg-start"
          color="primary"
          :to="{ name: 'cardPaymentConfigCreate', params: {} }"
        >
          Add New
        </v-btn>
      </div>
      <div>
        <v-switch @change="search" v-model="activeOnly" label="Show Active Only"/>
      </div>

      <div class="table-container">
        <v-data-table
          :headers="headers"
          :items="cardPaymentConfigList"
          :items-per-page="pagination.pageSize"
          :loading="!cardPaymentConfigProcessed"
          :server-items-length="pagination.totalSize"
          :page="pagination.current"
          :disable-pagination="
            !cardPaymentConfigList || cardPaymentConfigList.length < 1
          "
          :hide-default-header="
            !cardPaymentConfigList || cardPaymentConfigList.length < 1
          "
          :hide-default-footer="
            !cardPaymentConfigList || cardPaymentConfigList.length < 1
          "
          :options.sync="options"
          item-key="id"
          class="elevation-1"
          @update:options="pageChanged"
        >
          <template v-slot:item.label="{ item }">
            {{ item.label}} <span v-if="!item.active">(Inactive)</span>
          </template>

          <template v-slot:item.options="{ item }">
            <div style="white-space: nowrap;"> Accept E-check: {{item.allowAch}} </div>
            <div style="white-space: nowrap;"> Credit Card Fees: {{item.defaultCCFees ? item.defaultCCFees:0}}% </div>
            <div style="white-space: nowrap;"> Tax Rate: {{item.defaultTaxRate ? item.defaultTaxRate:0}}% </div>
          </template>

          <template v-slot:item.location="{ item }">
            {{ item.center ? item.center.name : 'Location: N/A' }}
          </template>

          <template v-slot:item.api="{ item }">
            <div style="white-space: nowrap;"> Transaction Key: {{item.transactionKey}} </div>
            <div style="white-space: nowrap;"> Client Key: {{item.clientKey}} </div>
            <div style="white-space: nowrap;"> Api Login ID: {{item.apiLoginId}} </div>
            <div style="white-space: nowrap;"> Accept.js URL: {{item.acceptjsUrl}} </div>
          </template>

          <template v-slot:item.paymentProcessor="{ item }">
            {{ item.paymentProcessor }} <span v-if="item.sandbox" >(Sandbox)</span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="edit(item)">
              mdi-pencil
            </v-icon>
            <v-icon small class="mr-2" @click="remove(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </div>
    </div>
    <confirmation-dialog ref="confirm" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const ConfirmationDialog = () =>
  import("@/components/common/ConfirmationDialog.vue");

export default {
  data() {
    return {
      pagination: {
        current: 1,
        pageSize: 10,
        totalSize: 100
      },
      options: {
        //define default sorting option here.
        sortBy: [],
        sortDesc: []
      },
      cardPaymentConfigList: [],
      showParentPage: true,
      activeOnly: true,
      headers: [
        {
          text: "label",
          value: "label",
          align: "start",
          sortable: false
        },
        {
          text: "Active",
          value: "active",
          align: "start",
          sortable: false
        },
        {
          text: "Sandbox",
          value: "sandbox",
          align: "start",
          sortable: false
        },
        {
          text: "Location",
          value: "location",
          align: "start",
          sortable: false
        },
        {
          text: "Payment Processor",
          value: "paymentProcessor",
          align: "start",
          sortable: false
        },
        {
          text: "Options",
          value: "options",
          align: "start",
          sortable: false
        },
        
        {
          text: "API",
          value: "api",
          align: "start",
          sortable: false
        },
        { text: "Actions", value: "actions", align: "end", sortable: false }
      ],
      sort: {
        key: null
      },
      searchTerms: ""
    };
  },
  components: {
    ConfirmationDialog
  },
  computed: {
    ...mapGetters("cardPaymentConfig", [
      "cardPaymentConfigProcessed",
      "getCardPaymentConfigs"
    ])
  },
  methods: {
    ...mapActions("messages", [
      "addErrorMessage",
      "addMessage",
      "addSuccessMessage"
    ]),
    ...mapActions("cardPaymentConfig", [
      "deleteCardPaymentConfig",
      "fetchCardPaymentConfigs"
    ]),
    view(item) {
      this.$router.push({
        name: "cardPaymentConfigView",
        params: { id: item.id }
      });
    },
    edit(item) {
      this.$router.push({
        name: "cardPaymentConfigEdit",
        params: { id: item.id }
      });
    },
    async remove(item) {
      let confirm = await this.$refs.confirm.open(
        "Confirm Delete",
        "Do you want to delete this cardPaymentConfig?"
      );
      if (confirm) {
        this.deleteCardPaymentConfig(item.id)
          .then(() => {
            this.addSuccessMessage(
              "cardPaymentConfig was deleted with successfull!"
            );
            this.getResources();
          })
          .catch(() => {
            this.addErrorMessage("Server response with error ");
          });
      }
    },
    getResources() {
      //default to sorting by ID desc if not defined
      const sortBy =
        this.options["sortBy"] && this.options["sortBy"].length > 0
          ? this.options.sortBy[0]
          : "id";
      const sortDesc =
        this.options["sortDesc"] && this.options["sortDesc"].length > 0
          ? this.options.sortDesc[0]
          : true;
      const params = {
        page:
          this.pagination.pageIndex && this.pagination.pageIndex > 0
            ? this.pagination.pageIndex - 1
            : 0,
        size: this.pagination.pageSize,
        sort: `${sortBy}${sortDesc ? ",desc" : ""}`,
      };

      if(this.activeOnly){
        params.active = true;
      }
      this.fetchCardPaymentConfigs(params)
        .then(response => {
          if (response) {
            this.pagination.totalSize = response.totalElements;
            this.cardPaymentConfigList = response.content;
          }
        })
        .catch(error => {
          this.addErrorMessage("Server response with error " + error);
        });
    },
    showParent(show) {
      this.showParentPage = show;
    },
    pageChanged(pagination) {
      this.pagination.pageIndex = pagination.page;
      this.pagination.pageSize = pagination.itemsPerPage;

      this.getResources();
    },
    search() {
      this.getResources();
    },
    clearSearch() {
      this.searchTerms = null;
      this.getResources();
    }
  },
  watch: {
    "pagination.numberRegisterForPage": function() {
      this.pagination.current = -1;
    }
  },
  beforeRouteUpdate(to, from, next) {
    const toDepth = to.path.split("/").length;
    const fromDepth = from.path.split("/").length;
    this.showParentPage = toDepth < fromDepth;
    if (this.showParentPage) {
      this.getResources();
    }
    next();
  }
};
</script>
